import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  navLinks = [
    // {
    //   url: ['/dashboard', 'page'],
    //   title: "Pages",
    //   icon: ""
    //   // <i class="fa-solid fa-file-lines"></i>
    // },
    {
      url: ['/dashboard', 'blog'],
      title: "Blog Posts",
      icon: "fa-solid fa-copy"
      // <i class="fa-solid fa-copy"></i>
    },
    {
      url: ['/dashboard', 'user'],
      title: "Users",
      icon: "fa-solid fa-user"
    },
    // {
    //   url: ['/dashboard', 'media'],
    //   title: "Media",
    //   icon: ""
    // },
    // {
    //   url: ['/dashboard', 'profile'],
    //   title: "Profile",
    //   icon: ""
    // },
    // {
    //   url: ['/dashboard', 'houses'],
    //   title: "Houses",
    //   icon: ""
    // },
  ]

}
